<!--
 * @Author: 邱扬
 * @LastEditors: 邱扬
 * @description: page description
 * @Date: 2021-09-15 13:19:30
 * @LastEditTime: 2021-09-15 13:46:20
-->
<template>
  <van-overlay :show="show" class="order-loading">
    <div class="wrapper">
      <div class="block">
        <van-loading color="#1989fa" class="loading" />
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
    }
  },
}
</script>

<style scoped lang="scss">
.order-loading {
  height: calc(100vh - 350px);
  top: 316px;
  background: #fff;
  opacity: 0.8;

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

    .block {
      width: 120px;
      height: 120px;

      .loading {
        position: relative;
        top: 50%;
        text-align: center;
        transform: translateY(-50%);
      }
    }
  }
}
</style>
